export enum COMMANDS {
  EXECUTE_KEYPRESS = 'execute-keypress'
}

export const onExecuteKeypress = (onExecute: Function) => {
  return {
    name: COMMANDS.EXECUTE_KEYPRESS,
    bindKey: {
      win: 'Ctrl-Enter',
      mac: 'Command-Enter'
    },
    exec: function exec(editor: any, args: any) {
      onExecute && onExecute();
    }
  };
};
